import { ToggleButton } from '@fluentui/react-components';
import { CommentRegular } from '@fluentui/react-icons';

import { TDocument, TDraft, TVersion } from '@modules/documents';
import { TFile, TFileVersion } from '@modules/files';
import { EItemScreenMode, getVersionId, useItemScreenStore } from '@modules/items';
import { ControlledTooltip } from '@shared/components';
import { showCommentForVersion } from '../helpers/showCommentForVersion.helper';
import { useMemo } from 'react';
import { TInlineBlock, TInlineBlockDraft, TInlineBlockVersion } from '@modules/inlineBlocks';

type TProps = {
  item: TDocument | TFile | TInlineBlock;
  version: TVersion | TFileVersion | TDraft | TInlineBlockVersion | TInlineBlockDraft | undefined;
  disabledMessage?: string;
};

const CommentsHeaderButton = ({ item, version, disabledMessage }: TProps) => {
  const { screenMode, setScreenMode } = useItemScreenStore();
  const isCommentsOpen = screenMode === EItemScreenMode.COMMENTS;

  const versionId = version ? getVersionId(version) : undefined;
  const numUnresolvedComments = useMemo(
    () =>
      item.comments.filter(
        (comment) => !comment.resolvedDate && versionId && showCommentForVersion(comment, versionId) // e.g. "5.1" or "draft"
      ).length,
    [item.comments, versionId]
  );

  return (
    <ControlledTooltip
      relationship="inaccessible"
      enable={Boolean(disabledMessage)}
      content={disabledMessage || ''}
      withArrow={true}
    >
      <ToggleButton
        size="small"
        checked={isCommentsOpen}
        icon={<CommentRegular />}
        disabled={Boolean(disabledMessage)}
        onClick={() => setScreenMode(isCommentsOpen ? undefined : EItemScreenMode.COMMENTS)}
      >
        Comments
        {numUnresolvedComments > 0 && ` (${numUnresolvedComments})`}
      </ToggleButton>
    </ControlledTooltip>
  );
};

export default CommentsHeaderButton;
